




































































































import Vue from 'vue';
import CustomerRemark from '../../models/CustomerRemark';
import customerClient from '../../apis';
import customerVuex from '../../vuex/common';
import { RemarkGroup } from '@/customer/models/RemarkGroup';

const remarks: CustomerRemark[] = [];
const selectedRemarks: CustomerRemark[] = [];
const selectedRemark: CustomerRemark | undefined = undefined;

export interface Remark {
  id: number;
  name: string;
}

//这个组件耦合 customerFilter，这个是不合理的
export default Vue.extend({
  mixins: [customerVuex],
  props: {
    show: {
      type: Boolean,
      default: false,
    },
    multi: {
      type: Boolean,
      default: true,
    },
    enableGroup: {
      type: Boolean,
      default: false,
    },
    initRemarks: {
      type: Array,
      default: () => [] as Array<number>,
    },
    initGroups: {
      type: Array,
      default: () => [] as Array<number>,
    },
  },
  data() {
    return {
      showRemarkBox: false,
      showSearchClose: false,
      page: 1,
      total: 0,
      size: 50,
      remarks,
      remarkGroups: [] as Array<RemarkGroup>,
      selectedRemarks,
      initSelected: [] as Array<CustomerRemark>,
      selectedGroups: [] as Array<RemarkGroup>,
      selectedRemark,
      keyword: null,
      loaded: false,
      loading: true,
    };
  },
  computed: {
    selectedAndInitRemarks(): Array<CustomerRemark> {
      return [].concat(this.selectedRemarks || []).concat(this.initSelected || []);
    },
    selectableRemarks(): Array<CustomerRemark> {
      return this.remarks.filter((r: CustomerRemark) => {

        const notInInit = (this.initRemarks || []).indexOf(r.id) === -1
        const findInSelected = (this.selectedRemarks || []).find((rr: CustomerRemark) => rr.id === r.id);
        return notInInit && !findInSelected;
      });
    },
    selectableGroups(): Array<RemarkGroup> {
      return this.remarkGroups.filter((e: RemarkGroup) => {
        const find = this.selectedGroups.find(g => {
          return g.id === e.id;
        });
        return find === undefined || find === null;
      });
    },
  },
  methods: {
    clearSelected(): void {
      this.selectedRemarks = [];
    },
    loadRemarkGroups(): void {
      customerClient.getRemarkGroups({}).success((r: any) => {
        this.remarkGroups = r.remarkGroups;
      });
    },
    loadRemarks() {
      this.loading = true;
      customerClient.getRemarks({
        keyword: this.keyword,
        page: this.page,
        size: this.size,
      }).success((r: any) => {
        this.loading = false;
        this.remarks = r.remarks;
        this.total = r.total;
        this.loaded = true;
      });
    },
    inSelectedRemarks(remark: CustomerRemark): boolean {
      return this.selectedRemarks.some((r: any) => {
        return r.id === remark.id;
      });
    },
    selectGroup(group: RemarkGroup): void {
      this.selectedGroups.push(group);
    },
    unselectGroup(group: RemarkGroup): void {
      const index = this.selectedGroups.indexOf(group);
      if (index !== -1) {
        this.selectedGroups.splice(index, 1);
      }
    },
    selectRemark(remark: CustomerRemark) {
      if (this.multi) {
        if (!this.inSelectedRemarks(remark)) {
          this.selectedRemarks.push(remark);
        }
      } else {
        this.selectedRemark = remark;
      }
    },
    deleteRemark(remark: CustomerRemark) {
      for (let i = 0; i < this.selectedRemarks.length; i++) {
        if (this.selectedRemarks[i].id === remark.id) {
          this.selectedRemarks.splice(i, 1);
        }
      }
      for (let i = 0; i < this.initSelected.length; i++) {
        if (this.initSelected[i].id === remark.id) {
          this.initSelected.splice(i, 1);
        }
      }
    },
    copyGroups(gs: RemarkGroup[]): RemarkGroup[] {
      return JSON.parse(JSON.stringify(gs));
    },
    copyRemarks(remarks: CustomerRemark[]): CustomerRemark[] {
      return JSON.parse(JSON.stringify(remarks));
    },
    copyRemark(remark: CustomerRemark): CustomerRemark {
      return JSON.parse(JSON.stringify(remark));
    },
    updateRelation(notIn: boolean, or: boolean) {
      const v = this.customerState.customerFilter.remark;
      v.notIn = notIn;
      v.or = or;
      this.updateRemarkFilter(v);
    },
    close() {
      this.$emit('close');
    },
    confirmRemarks() {
      if (this.multi) {
        const remarks = this.copyRemarks(this.selectedAndInitRemarks);
        const groups = this.copyGroups(this.selectedGroups);
        this.$emit('confirm', remarks, groups);
      } else {
        this.$emit('confirm', this.copyRemark(this.selectedRemark));
      }
    },
    onPageChange(page: number) {
      this.page = page;
      this.loadRemarks();
    },
    loadInitRemarks(): void {
      customerClient.getFullRemarksByIds({
        ids: this.initRemarks,
      }).success( (rm: any) => {
        this.initSelected = rm.remarks;
      });
    },
  },
  mounted() {
    if(!this.multi && this.enableGroup) {
      this.$Message.warning('标签组筛选仅支持多multi模式');
    }

    const remarks = this.customerState.customerFilter.remark.remarks;
    const groups = this.customerState.customerFilter.remark.remarkGroups;
    if(remarks) {
      this.selectedRemarks = this.copyRemarks(remarks);
    }
    if(groups) {
      this.selectedGroups = this.copyGroups(groups);
    }
    this.showRemarkBox = this.show;
  },
  watch: {
    show(val: boolean): void {
      this.showRemarkBox = this.show;
      if (val) {
        this.loadRemarks();
        this.loadInitRemarks();
        if(this.enableGroup) {
          this.loadRemarkGroups();
        }
      }
    },
    keyword() {
      if (this.keyword && this.keyword.trim() !== '') {
        this.showSearchClose = true;
      }
      this.loadRemarks();
      if(this.enableGroup) {
        this.loadRemarkGroups();
      }
    },
  },
});
